import React from 'react';
import styled from 'styled-components';
import { Grids, ColorPalettes, Breakpoints } from 'kinedu-react-components';
import StepLabels from './StepLabels';
import { IStep } from '../../containers/ObContainer';
import ClassroomsLogo from '../shared/ClassroomsLogo';

const { KineduPalette } = ColorPalettes;

const StyledOBFrame = styled.div`
  ${Grids.mobile}
  width: 100%;
  height: 100vh;
  background-color: #cfd5da;

  ${Breakpoints.desktop} {
    ${Grids.ob}
    width: 100%;
    height: 100vh;
  }
`;

const LeftSideView = styled.div`
  grid-column: 1 / 6;
  grid-row: 1 / 4;
  background-color: ${KineduPalette.newKinedu};
`;

const StepViewFrame = styled.div`
  position: relative;
  grid-column: 1 / 7;
  grid-row: 1 / 4;
  border-radius: 0px;
  background-color: white;

  ${Breakpoints.desktop} {
    position: relative;
    grid-column: 5 / 13;
    grid-row: 2 / 3;
    border-radius: 4px;
    background-color: white;
  }
`;

const LogoContainer = styled.span`
  position: relative;
  display: block;
  top: 4%;
  left: 9%;
`;

const Content = styled.div``;

interface OBFrameProps {
  children: {};
  steps: IStep[];
  goToStep: (index: number) => void;
}

const OBFrame: React.FC<OBFrameProps> = ({ children, steps, goToStep }) => (
  <StyledOBFrame>
    <LeftSideView>
      <LogoContainer>
        <ClassroomsLogo size={350} alt lang={localStorage.i18nextLng} />
      </LogoContainer>
    </LeftSideView>
    <StepViewFrame>
      <StepLabels items={steps} goToStep={goToStep} />
      <Content>{children}</Content>
    </StepViewFrame>
  </StyledOBFrame>
);

export default OBFrame;
